import React from "react";
import CrudManager from "@/components/admin/CrudManager";

export default function Testimonials() {
  return (
    <CrudManager
      title="Testimonials"
      description="Manage customer testimonials shown on the site."
      endpoint="testimonials"
      fields={[
        { name: "name", label: "Customer Name", type: "text" },
        { name: "role", label: "Role / Company", type: "text" },
        { name: "quote", label: "Testimonial", type: "textarea", rows: 4 },
        { name: "rating", label: "Rating (1-5)", type: "number" },
        { name: "image", label: "Photo (optional)", type: "image" },
        { name: "order", label: "Display Order", type: "number" },
        { name: "active", label: "Visible", type: "switch" },
      ]}
      columns={[
        { name: "name", label: "Name", type: "text" },
        { name: "role", label: "Role", type: "text" },
        { name: "rating", label: "Rating", type: "number" },
        { name: "active", label: "Status", type: "switch" },
      ]}
    />
  );
}
